"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotice = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var button_1 = require("../button");
var icon_1 = require("../icon");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var i18n_1 = require("../i18n");
exports.AlertNotice = react_1.default.forwardRef(function AlertNotice(_a, ref) {
    var title = _a.title, children = _a.children, className = _a.className, open = _a.open, defaultOpen = _a.defaultOpen, onOpenChange = _a.onOpenChange, props = tslib_1.__rest(_a, ["title", "children", "className", "open", "defaultOpen", "onOpenChange"]);
    var _b = tslib_1.__read(use_default_1.useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _b[0], setIsOpened = _b[1];
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation();
    var alertClassName = classnames_1.default(classPrefix + "-alert", classPrefix + "-alert--notice", isOpened && "is-expanded", className);
    var alertElement = (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: alertClassName }, props),
        react_1.default.createElement("span", { className: classPrefix + "-alert__decoration" },
            react_1.default.createElement(icon_1.Icon, { type: "notice-blue" })),
        react_1.default.createElement("div", { className: classPrefix + "-alert__info" },
            react_1.default.createElement("p", null, title),
            isOpened && children),
        react_1.default.createElement("div", { className: classPrefix + "-alert__operational" }, children && (react_1.default.createElement(button_1.Button, { type: "icon", htmlType: "button", icon: isOpened ? "arrowup" : "arrowdown", "aria-label": isOpened ? t.collapse : t.expand, onClick: function () { return setIsOpened(!isOpened); } })))));
    return alertElement;
});
exports.AlertNotice.displayName = "AlertNotice";
//# sourceMappingURL=AlertNotice.js.map